export default {"src":"/_next/static/media/sp.53a8e5eb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};